import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  create_address,
  delete_address,
  fetch_addresses,
  set_default_address,
  update_address,
  type AddressInput,
} from './api';

const ADDRESSES_KEY = ['user', 'addresses'] as const;

export function use_addresses() {
  return useQuery({ queryKey: ADDRESSES_KEY, queryFn: fetch_addresses, staleTime: 0, retry: 0 });
}

export function use_address_mutations() {
  const qc = useQueryClient();
  const invalidate = () => qc.invalidateQueries({ queryKey: ADDRESSES_KEY });

  const create = useMutation({
    mutationFn: (input: AddressInput) => create_address(input),
    onSuccess: invalidate,
  });
  const update = useMutation({
    mutationFn: ({ id, input }: { id: string; input: Partial<AddressInput> }) =>
      update_address(id, input),
    onSuccess: invalidate,
  });
  const remove = useMutation({
    mutationFn: (id: string) => delete_address(id),
    onSuccess: invalidate,
  });
  const set_default = useMutation({
    mutationFn: (id: string) => set_default_address(id),
    onSuccess: invalidate,
  });

  return { create, update, remove, set_default };
}
